import type { FieldProps, State } from '../types';

type VisitData = { gruppo_dv: number; codice_dv: number; valore_dv: number }[];
type TestType = { codice: string; name: string }[];

export const preparePayloadForDatoVisita = (state: State, testTypeCode: number) => {
  // positive group (excluding carrier) and not type of test, with values
  const dato_visita: VisitData = Object.keys(state).flatMap((key) =>
    state[key].group > 0 && state[key].code !== testTypeCode && state[key].value !== ''
      ? {
          gruppo_dv: state[key].group,
          codice_dv: Number(state[key].code),
          valore_dv: Number(state[key].value),
        }
      : [],
  );
  // type of test - prende un campo solo ma l'ho mantenuto dinamico
  const tipo_di_test: TestType = Object.keys(state).flatMap((key) =>
    state[key].code === testTypeCode && state[key].value !== ''
      ? state[key].value.map(({ fieldName, fieldValue }: FieldProps) => ({
          codice: fieldValue,
          name: fieldName,
        }))
      : [],
  );
  return {
    dato_visita,
    tipo_di_test,
  };
};
